export const parseBoolean = (env: string | undefined): boolean => env === 'true' || env === 'TRUE';
